// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/receivables/estimates/archive',
        component: () =>
            import('@/pages/[organisation]/receivables/estimates/archive.vue'),
        name: 'accounts-receivable.estimates.search-archived-estimates',
        meta: {
            loginRequired: true,
            permission: 'access.receivables.estimate.update-estimate',
        },
        children: [
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/receivables/estimates/archive/[id].vue'),
                name: 'accounts-receivable.estimates.view-archived-estimate',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.estimate.update-estimate',
                },
            },
        ],
    },

    {
        path: '/:organisation/receivables/estimates',
        component: () =>
            import('@/pages/[organisation]/receivables/estimates.vue'),
        name: 'accounts-receivable.estimates.search-estimates',
        meta: {
            loginRequired: true,
            permission: 'access.receivables.estimate.view-estimates',
        },

        children: [
            {
                path: 'create-estimate',
                component: () =>
                    import('@/pages/[organisation]/receivables/estimates/create-estimate.vue'),
                name: 'accounts-receivable.estimates.create-estimate',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.estimate.create-estimate',
                },
            },
            {
                path: ':id/update-estimate',
                component: () =>
                    import(/* webpackChunkName: "accounts-receivable.estimates" */ '@/pages/[organisation]/receivables/estimates/estimate/[id]/edit.vue'),
                name: 'accounts-receivable.estimates.update-estimate',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.estimate.update-estimate',
                },
            },
            {
                path: ':id/duplicate',
                component: () =>
                    import(/* webpackChunkName: "accounts-receivable.estimates" */ '@/pages/[organisation]/receivables/estimates/duplicate-estimate.vue'),
                name: 'accounts-receivable.estimates.duplicate-estimate',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.estimate.update-estimate',
                },
            },
            {
                path: ':id/convert-estimate-to-invoice',
                component: () =>
                    import(/* webpackChunkName: "accounts-receivable.estimates" */ '@/pages/[organisation]/receivables/estimates/convert-estimate-to-invoice.vue'),
                name: 'accounts-receivable.estimates.convert-estimate-to-invoice',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.estimate.create-estimate',
                },
            },
            {
                path: ':id/convert-estimate-to-proforma-invoice',
                component: () =>
                    import(/* webpackChunkName: "accounts-receivable.estimates" */ '@/pages/[organisation]/receivables/estimates/convert-estimate-to-pro-forma-invoice.vue'),
                name: 'accounts-receivable.estimates.convert-estimate-to-proforma-invoice',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.estimate.create-estimate',
                },
            },
            {
                path: ':id',
                component: () =>
                    import(/* webpackChunkName: "accounts-receivable.estimates" */ '@/pages/[organisation]/receivables/estimates/estimate/[id].vue'),
                name: 'accounts-receivable.estimates.view-estimate',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.estimate.view-estimates',
                },
                // children: [
                //     {
                //         path: 'email-estimate',
                //         component: () =>
                //             import(
                //                 /* webpackChunkName: "accounts-receivable.estimates" */
                //                 '@/app/accounts-receivable/estimates/views/EmailEstimate.vue'
                //             ),
                //         name: 'accounts-receivable.estimates.email-estimate',
                //         meta: {
                //             loginRequired: true,
                //             permission: 'access.receivables.estimate.update-estimate',
                //         },
                //     },
                // ],
            },
            {
                path: ':id/history',
                component: () =>
                    import(/* webpackChunkName: "accounts-receivable.estimates" */ '@/pages/[organisation]/receivables/estimates/estimate-history.vue'),
                name: 'accounts-receivable.estimates.view-estimate-history',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.estimate.view-estimates',
                },
            },
        ],
    },
];
